module.exports = __webpack_public_path__ + "40a2a03ce752576129d111e399c8302f.png";